import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ElofizetesRoutingModule } from './elofizetes-routing.module';
import { ElofizetesComponent } from './elofizetes/elofizetes.component';
import { FizetesComponent } from './fizetes/fizetes.component';
import { OsszegzesComponent } from './osszegzes/osszegzes.component';
import { SikeresKurzusComponent } from './sikeres-kurzus/sikeres-kurzus.component';
import { SikertelenKurzusComponent } from './sikertelen-kurzus/sikertelen-kurzus.component';




@NgModule({
  declarations: [
    ElofizetesComponent,
    FizetesComponent,
    OsszegzesComponent,
    SikeresKurzusComponent,
    SikertelenKurzusComponent
  ],
  imports: [
    CommonModule,
    ElofizetesRoutingModule,
    FormsModule, ReactiveFormsModule
  ]
})
export class ElofizetesModule { }
